<template>
  <v-btn
    class="btn-style-3"        
    :class="customClass"
    :href="hrefLink"        
  >
    <slot>
      Pruébalo Gratis
    </slot>    
  </v-btn>
</template>

<script>

export default {
  name: 'AppBtnStyle3',

  props: {      
    hrefLink: {
      type: String,
      required: true
    },
    customClass: {
      type: String,
      default: ''
    },            
  },
  data() {
    return {    
    }
  },
  computed: {
  }
}
</script>

<style scoped>
.btn-style-3 {
    text-align: center;           
    background-color: transparent !important;    
    height: 30px !important;
    border-radius: 28px;
    background: linear-gradient(92deg, #9CF0FA 2.48%, #3CF 102.72%);
    padding: 10px 30px 11px 30px !important;
  }
  .btn-style-3  >>> .v-btn__content {
    color:var(--v-primary_blue-base);
    text-transform: none;
    font-family: Kanit;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: normal;
  }
  </style>